import zIndex from '@material-ui/core/styles/zIndex'

const styles = theme => ({
  standAloneDiv: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '4px',
    backgroundColor: '#fff',
    borderRadius: '8px',
    padding: '8px',
    '&:hover': {
      cursor: 'pointer',
    },
  },

  drawer: {
    width: '280px',
    flexShrink: 0,
    whiteSpace: 'nowrap',
    position: 'relative',
  },
  drawerOpen: {
    width: '280px',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    position: 'fixed',
    height: 'calc(100%)',

    borderTopLeftRadius: '0',
    borderTopRightRadius: '16px',
    borderBottomLeftRadius: '0',
    borderBottomRightRadius: '16px',
    /*  overflowY: 'hidden',
    overflowX: 'hidden',
    '&:hover': {
      overflowY: 'auto',
      overflowX: 'hidden',
    }, */
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(7),
    position: 'fixed',

    borderTopLeftRadius: '0',
    borderTopRightRadius: '16px',
    borderBottomLeftRadius: '0',
    borderBottomRightRadius: '16px',
    height: 'calc(100%)',
  },
  drawerOpenPaper: {
    width: '280px',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    position: 'relative',
    backgroundColor: '#F4F6F8',
    borderRadius: '16px',
    border: 'none',
    padding: '10px',
    overflow: 'inherit',
    gap: '12px',
    top: '-60 !important',
    borderTopLeftRadius: '0',
    borderTopRightRadius: '16px',
    borderBottomLeftRadius: '0',
    height: 'calc(100% - 56px)',
    borderBottomRightRadius: '16px',
  },
  drawerClosePaper: {
    height: 'calc(100% - 56px)',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    top: 57,
    padding: '12px',
    overflowX: 'hidden',
    width: theme.spacing(7),
    position: 'fixed',
    backgroundColor: '#F4F6F8',
    borderTopLeftRadius: '0',
    borderTopRightRadius: '16px',
    borderBottomLeftRadius: '0',
    borderBottomRightRadius: '16px',
    border: 'none',
    zIndex: 1200,
  },
  sectionDiv: {
    height: '100%',
    backgroundColor: '#F4F6F8',
    color: '#002E47',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    overflow: 'hidden',
    '&:hover': {
      overflow: 'auto',
      overflowY: 'scroll',
      overflowX: 'hidden',
    },
    '&::-webkit-scrollbar': {
      width: '4px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#F4F6F8',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#CBD5E0',
      borderRadius: '4px',
      '&:hover': {
        background: '#A0AEC0',
      },
    },
    '&::-webkit-scrollbar-track-piece:start': {
      backgroundColor: 'transparent',
      marginTop: '16px',
    },
    '&::-webkit-scrollbar-track-piece:end': {
      backgroundColor: 'transparent',
      marginBottom: '16px',
    },
  },
  sectionDivClose: {
    overFlowY: 'hidden !important',
    '&:hover': {
      overflowY: 'hidden',
      overflowX: 'hidden',
    },
  },
})

export default styles
